// File: client/src/variants/party/rulebook.js
// Canonical rulebook for Party Chess.

const rulebook = {
  overview:
    'Chess as a party game. Every 4 full turns you’re offered three random modifiers and pick one — grab a bonus queen, take an extra move, promote a pawn, and more. Upbeat and unpredictable, never mean.',
  objective:
    'Checkmate the opponent’s king while riding the party modifiers to your advantage.',
  setup:
    'Standard starting position. The first vote appears after 4 full turns.',
  turnFlow: [
    'Make one normal legal move.',
    'Every 4 full turns, the player about to move is offered THREE random modifiers.',
    'Pick one — it applies immediately. (You can’t move until you’ve chosen.)',
    'In single-player, the computer auto-picks on its own turns.',
  ],
  mechanics: [
    {
      title: 'Party modifiers',
      items: [
        '👑 Extra Queen — a bonus queen appears on a random empty square for you.',
        '➕ Bonus Turn — take an extra move right now.',
        '🎁 Gift — one of your pawns is promoted to a queen.',
        '🐴 Knight Fever — your pieces move like knights next turn.',
        '🔄 / ✨ / 🎲 / 🔀 / ⬇️ — friendly board shake-ups (rotation, teleport, promotion, swap, gravity).',
      ],
    },
    {
      title: 'Voting',
      body: 'Three options are drawn at random from the party pool and offered to the current player. In two-player local games each player picks on their own vote; versus the computer, it picks for itself.',
    },
  ],
  winConditions: [
    'Win by checkmate.',
    'Win if the opponent resigns or runs out of time.',
    'Stalemate is a draw.',
  ],
  tips: [
    'Bonus Turn is great for a two-part tactic — set up, then strike.',
    'Extra Queen and Gift swing material hard; grab them when offered.',
    'The destructive Meteor is intentionally left OUT of the party pool — the mood stays light.',
  ],
  knownInteractions: [
    'Rule decision: a vote appears every 4 FULL turns for the side about to move; you cannot move until you pick (the board is gated).',
    'Rule decision: modifiers that benefit “you” (Extra Queen, Gift) benefit the CHOOSER.',
    'Rule decision: Meteor is excluded from the party pool to keep Party Chess non-destructive.',
    'Rule decision: kings are never destroyed by any party modifier.',
    'AI: versus the computer, it auto-picks a random modifier on its own votes. For simplicity the AI skips the “Bonus Turn” grant (it plays a single standard move). Documented limitation.',
  ],
};

export default rulebook;
